<template>
  <div class="home">
    <div>求真易学社</div>
    <div style="margin-top: 10px">
      <label for="birthday-date">阳历生日：</label>
    </div>
    <div
      class="birthday-input"
      @click="showModal = true"
      style="display: inline-block; width: 250px; max-width: 85%"
    >
      {{ currentYear }}-{{ currentMonth }}-{{ currentDay }}
    </div>
    <div style="margin-top: 15px">
      <label for="birthday-time">钟表时间：</label>
    </div>
    <div
      class="birthday-input"
      @click="showTimePickerModal = true"
      style="display: inline-block; width: 250px; max-width: 85%"
    >
      {{ String(currentHour).padStart(2, '0') }}
      :
      {{ String(currentMinute).padStart(2, '0') }}
    </div>
    <!-- <div style="margin-top: 15px">
      <label for="daylight">夏令时：</label>
      <input
        type="radio"
        id="daylight-true"
        name="daylight"
        value="1"
        v-model="daylight"
        style="width: 24px; height: 24px"
      />
      <label for="daylight-true">是</label>
      <input
        type="radio"
        id="daylight-false"
        name="daylight"
        value="0"
        v-model="daylight"
        style="width: 24px; height: 24px"
      />
      <label for="daylight-false">否</label>
    </div> -->
    <div style="margin-top: 15px">
      <label>出生地：</label>
    </div>
    <div style="display: flex; justify-content: space-evenly">
      <select
        name="area-level1"
        id="area-level1"
        v-model="selectAreaLevel1"
        class="area-select"
      >
        <option
          v-for="(item, index) in areaLevel1"
          :key="index"
          :value="item.code"
        >
          {{ item.name }}
        </option>
      </select>
      <select
        name="area-level2"
        id="area-level2"
        v-model="selectAreaLevel2"
        class="area-select"
      >
        <option value="-1">-----</option>
        <option
          v-for="(item, index) in areaLevel2.filter(
            (item) => item.parentCode == selectAreaLevel1
          )"
          :key="index"
          :value="item.code"
        >
          {{ item.name }}
        </option>
      </select>
      <!-- <select
        name="area-level3"
        id="area-level3"
        v-model="selectAreaLevel3"
        class="area-select"
      >
        <option value="-1">-----</option>
        <option
          v-for="(item, index) in areaLevel3.filter(
            (item) => item.parentCode == selectAreaLevel2
          )"
          :key="index"
          :value="item.code"
        >
          {{ item.name }}
        </option>
      </select> -->
    </div>
    <div style="margin-top: 15px">
      <label for="gender">性别：</label>
      <input
        type="radio"
        id="male"
        name="gender"
        value="1"
        v-model="gender"
        style="width: 24px; height: 24px"
      />
      <label for="male">男</label>
      <input
        type="radio"
        id="female"
        name="gender"
        value="2"
        v-model="gender"
        style="width: 24px; height: 24px"
      />
      <label for="female">女</label>
    </div>
    <div style="margin-top: 30px">
      <button @click="submit()" style="font-size: 30px">排盘</button>
    </div>
    <Teleport to="body">
      <!-- use the modal component, pass in the prop -->
      <date-picker-modal
        :show="showModal"
        :year="currentYear"
        :month="currentMonth"
        :day="currentDay"
        @modal-submit="modalSubmit"
        @close="showModal = false"
      >
      </date-picker-modal>
      <!-- use the modal component, pass in the prop -->
      <time-picker-modal
        :show="showTimePickerModal"
        :hour="currentHour"
        :minute="currentMinute"
        @modal-submit="timeModalSubmit"
        @close="showTimePickerModal = false"
      >
      </time-picker-modal>
    </Teleport>
  </div>
</template>
<script>
import moment from 'moment-timezone'

import DatePickerModal from '@/components/DatePickerModal.vue'
import TimePickerModal from '@/components/TimePickerModal.vue'

import { AREAS } from '@/constant/china'

export default {
  name: 'InputDataVue',
  data: function () {
    return {
      currentYear: 1970,
      currentMonth: 7,
      currentDay: 15,
      currentHour: 12,
      currentMinute: 0,
      gender: '1',
      daylight: '0',
      selectAreaLevel1: '110000',
      selectAreaLevel2: '-1',
      selectAreaLevel3: '-1',
      showModal: false,
      showTimePickerModal: false,
    }
  },
  components: {
    DatePickerModal,
    TimePickerModal,
  },
  mounted: async function () {
    // 首先获取视窗高度，再乘以1%得到vh单位的值
    let vh = window.innerHeight * 0.01
    // 把--vh的值设置到文档的根元素中
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    if (window.localStorage.getItem('user') !== null) {
      const user = JSON.parse(window.localStorage.getItem('user'))
      const date = moment.tz(user.birthday, 'YYYY/MM/DD HH:mm', 'Etc/GMT-8')

      this.currentYear = date.year()
      this.currentMonth = date.month() + 1
      this.currentDay = date.date()

      this.currentHour = date.hour()
      this.currentMinute = date.minute()

      this.gender = user.gender

      const userLocation = user.location || 110000
      const selectArea = AREAS.find((item) => item.code == userLocation)
      if (selectArea.level == 3) {
        const level2 = AREAS.find((item) => item.code == selectArea.parentCode)
        this.selectAreaLevel1 = AREAS.find(
          (item) => item.code == level2.parentCode
        ).code

        this.selectAreaLevel2 = level2.code

        this.selectAreaLevel3 = selectArea.code
      } else if (selectArea.level == 2) {
        this.selectAreaLevel1 = AREAS.find(
          (item) => item.code == selectArea.parentCode
        ).code
        this.selectAreaLevel2 = selectArea.code
      } else {
        this.selectAreaLevel1 = selectArea.code
      }

      // this.daylight = user.daylight || 0

      this.$watch('selectAreaLevel1', () => {
        this.selectAreaLevel2 = '-1'
        this.selectAreaLevel3 = '-1'
      })

      this.$watch('selectAreaLevel2', () => {
        this.selectAreaLevel3 = '-1'
      })
    }
  },
  computed: {
    user: function () {
      const birthday = moment.tz(
        this.birthdayDate +
          ' ' +
          String(this.currentHour).padStart(2, '0') +
          ':' +
          String(this.currentMinute).padStart(2, '0'),
        'YYYY-MM-DD HH:mm',
        'Etc/GMT-8'
      )

      const age = moment().tz('Etc/GMT-8').year() - birthday.year() + 1

      let location = this.selectAreaLevel3
      if (location == '-1') location = this.selectAreaLevel2
      if (location == '-1') location = this.selectAreaLevel1

      return {
        birthday: birthday.format('YYYY/MM/DD HH:mm'),
        gender: this.gender,
        location: location,
        daylight: this.daylight,
        age,
      }
    },
    birthdayDate: function () {
      const d =
        this.currentYear + '-' + this.currentMonth + '-' + this.currentDay
      return d
    },
    isClass: function () {
      return process.env.VUE_APP_USE_STARS === 'CLASS'
    },
    areaLevel1: function () {
      return AREAS.filter(function (item) {
        return item.level == 1
      })
    },
    areaLevel2: function () {
      return AREAS.filter(function (item) {
        return item.level == 2
      })
    },
    areaLevel3: function () {
      return AREAS.filter(function (item) {
        return item.level == 3
      })
    },
  },
  methods: {
    submit: function () {
      window.localStorage.setItem('user', JSON.stringify(this.user))
      this.$router.push({ name: 'Home' })
    },
    modalSubmit: function (year, month, day) {
      this.currentYear = year
      this.currentMonth = month
      this.currentDay = day
    },
    timeModalSubmit: function (hour, minute) {
      this.currentHour = hour
      this.currentMinute = minute
    },
  },
}
</script>
<style scoped>
.home {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  display: flex;
  font-size: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.area-select {
  text-align: center;
  font-size: 24px;
  flex: 1;
  /* width: 125px; */
  max-width: 45%;
}
</style>
